(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-recomendation"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    var recommended_url = productRecommendationsSection.dataset.baseUrl;

    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;

    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    // Build request URL
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    var relatedWrapper = productRecommendationsSection.closest('#related');
    var shopifySection = productRecommendationsSection.closest('.shopify-section');
    var recommended_url = productRecommendationsSection.dataset.baseUrl;
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;

    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    // Build request URL
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var fetchedRecommendations = container.querySelector(".product-recommendations");
        var fetchedRelated = container.querySelector("#related");

        if (fetchedRecommendations && fetchedRecommendations.innerHTML.trim() !== "") {
          productRecommendationsSection.parentElement.innerHTML = fetchedRecommendations.innerHTML;
          if (relatedWrapper) {
            relatedWrapper.style.display = "";
          }
          if (shopifySection) {
            shopifySection.style.display = "";
          }
        } else {
          if (relatedWrapper) {
            relatedWrapper.style.display = "none";
          }
          if (shopifySection) {
            shopifySection.style.display = "none";
          }
        }
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
